import { Route } from "react-router-dom";
import JobsList from '../modules/crm/jobs/views/JobsList';
import JobDetails from '../modules/crm/jobs/views/JobDetails';
import JobTypeGroupsList from '../modules/crm/base/views/JobTypeGroupsList';
import JobTypesList from '../modules/crm/base/views/JobTypesList';
import JobStatuses from '../modules/crm/base/views/JobStatuses';
import JobSourcesList from '../modules/crm/base/views/JobSourcesList';
import MetrosList from '../modules/crm/base/views/MetrosList';
import FlagsList from '../modules/crm/base/views/FlagsList';
import JobColorsList from '../modules/crm/base/views/JobColorsList';
import CancelReasonsList from '../modules/crm/base/views/CancelReasonsList';
import TagsList from '../modules/crm/base/views/TagsList';
import ClosedJobsList from '../modules/crm/jobs/views/ClosedJobsList';
import CanceledJobsList from '../modules/crm/jobs/views/CanceledJobsList';
import RatesList from '../modules/crm/rates/views/RatesList';
import AllJobsList from '../modules/crm/jobs/views/AllJobsList';
import JobInvoicesList from '../modules/crm/jobs/views/JobInvoicesList';
import JobsNewBoard from '../modules/crm/jobs/views/JobsDashboardNew';
import JobsBoardGuard from '../modules/crm/jobs/components/JobsBoardGuard';
import JobsCalendarView from '../modules/crm/jobs/views/JobsCalendarView';
import JobsMapView from '../modules/crm/jobs/views/JobsMapView';
import JobsReport from '../modules/reports/jobs/views/JobsReport';
import JobsReportMobile from '../modules/reports/jobs/views/JobsReportMobile';
import JobsReportTechMobile from '../modules/reports/jobs/views/JobsReportTechMobile';
import BalanceSheetView from '../modules/reports/jobs/views/BalanceSheetView';
import BalanceTransactionsList from '../modules/reports/jobs/views/BalanceTransactionsList';
import CRMMainView from '../modules/crm/views/CRMMainView';
import ReportsMainView from '../modules/reports/views/ReportsMainView';
import PaymentTransactionsList from '../modules/reports/payments/views/PaymentTransactionsList';
import CallsReport from '../modules/reports/calls/views/CallsReport';
import CRMJobBoardSettings from '../modules/system/settings/components/CRMJobBoardSettings';
import SendJobSettings from '../modules/system/settings/components/SendJobSettings';
import AutomaticSmsSettings from '../modules/crm/settings/views/AutomaticSmsSettings';
import AutomationRulesList from '../modules/crm/settings/views/AutomationRulesList';
import ChatSettingsView from '../modules/crm/settings/views/ChatSettingsView';
import PercallSettings from '../modules/crm/settings/views/PercallSettings';
import TaxesList from '../modules/system/taxes/views/TaxesList';
import { useGlobal, useScreen } from '../core/Global';


// Picks the phone-optimized Jobs Report on mobile, desktop version otherwise.
// Desktop JobsReport is intentionally never modified for the mobile refactor.
// useGlobal() subscribes so this re-evaluates once the window size is measured.
function JobsReportRoute() {
  useGlobal();
  const screen = useScreen();
  return screen.isMobile ? <JobsReportMobile /> : <JobsReport />;
}

function CRMRoutes() {
  let k = 0;
  return (
    [
      <Route key={k++} path="/boards/beta" element={<JobsBoardGuard><JobsNewBoard /></JobsBoardGuard>} />,
      <Route key={k++} path="/boards/jobs" element={<JobsBoardGuard><JobsNewBoard /></JobsBoardGuard>} />,
      <Route key={k++} path="/boards/grid" element={<JobsBoardGuard><JobsNewBoard grid /></JobsBoardGuard>} />,
      <Route key={k++} path="/boards/calendar" element={<JobsBoardGuard><JobsCalendarView /></JobsBoardGuard>} />,
      <Route key={k++} path="/boards/map" element={<JobsBoardGuard><JobsMapView /></JobsBoardGuard>} />,
      <Route key={k++} path="/crm/jobs/archived" element={<JobsList type='closed' />} />,
      <Route key={k++} path="/crm/jobs/:selectedPage/:selectedId" element={<JobDetails />} />,
      <Route key={k++} path="/crm/jobs/:selectedPage/:selectedId/view/:selectedObjectId" element={<JobDetails />} />,

      <Route key={k++} path="/mobile/reports" element={<JobsReportTechMobile />} />,

      <Route key={k++} path="/reports" element={<ReportsMainView />}>
        <Route path="jobs" element={<></>} />
        <Route path="jobs/:segment" element={<JobsReportRoute />} />
        <Route path="calls" element={<CallsReport />} />
        <Route path="balancesheet" element={<BalanceSheetView />} />
        <Route path="balancetransactions" element={<BalanceTransactionsList />} />
        <Route path="transactions" element={<PaymentTransactionsList />} />
      </Route>,

      <Route key={k++} path="/crm" element={<CRMMainView />}>
        <Route path="jobs/all" element={<AllJobsList />} />
        <Route path="jobs/closed" element={<ClosedJobsList />} />
        <Route path="jobs/canceled" element={<CanceledJobsList />} />
        <Route path="jobs/invoices" element={<JobInvoicesList />} />
        <Route path="rates/:cat" element={<RatesList />} />
        <Route path="base/jobtypegroups" element={<JobTypeGroupsList />} />
        <Route path="base/jobtypes" element={<JobTypesList />} />
        <Route path="base/jobstatuses" element={<JobStatuses />} />
        <Route path="base/jobsources" element={<JobSourcesList />} />
        <Route path="base/metros" element={<MetrosList />} />
        <Route path="base/flags" element={<FlagsList />} />
        <Route path="base/jobcolors" element={<JobColorsList />} />
        <Route path="base/cancelreasons" element={<CancelReasonsList />} />
        <Route path="base/tags" element={<TagsList />} />
        <Route path="base/taxes" element={<TaxesList />} />
        <Route path="settings/jobs-preferences" element={<CRMJobBoardSettings />} />
        <Route path="settings/send-job" element={<SendJobSettings />} />
        <Route path="settings/automation-rules" element={<AutomationRulesList />} />
        <Route path="settings/auto-messaging" element={<AutomaticSmsSettings />} />
        <Route path="settings/chats" element={<ChatSettingsView />} />
        <Route path="settings/percall" element={<PercallSettings />} />
      </Route>
    ]
  )
}

export default CRMRoutes;
